__turbopack_context__.v({
  "root": "OhBadge-module-scss-module__b9_ozq__root",
  "secondary": "OhBadge-module-scss-module__b9_ozq__secondary",
  "tertiary": "OhBadge-module-scss-module__b9_ozq__tertiary",
});
